export default __webpack_public_path__ + "static/media/Grandmas_sweet_store.86ba27d5.png";